import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useViewTransitionNav } from '@app/components/core/viewTransition';

/** The one way from a dashboard card into its detail: an arrow in the corner, so nothing else on the card is a link. */
const CardArrow = ({
  to,
  label,
  state,
  swipe = false,
}: {
  to: string;
  /** Said to screen readers and on hover, e.g. "Open Spend". */
  label: string;
  state?: Record<string, unknown>;
  /** A page of its own swipes in; another tab of the product fades, and replaces the entry like the tab bar. */
  swipe?: boolean;
}): JSX.Element => {
  const transitionNavigate = useViewTransitionNav();
  return (
    <Link
      to={to}
      replace={!swipe}
      state={state}
      aria-label={label}
      title={label}
      onClick={e => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        transitionNavigate(to, swipe ? 'forward' : 'fade', { replace: !swipe, state });
      }}
      className="inline-flex size-8 shrink-0 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground shadow-xs transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 print:hidden"
    >
      <ArrowUpRight className="size-4" />
    </Link>
  );
};

export default CardArrow;
